// extracted by mini-css-extract-plugin
module.exports = {"plate":"a10a3f92e9--plate--NGtr7","rur-image":"a10a3f92e9--rur-image--sLVOP","info-icon":"a10a3f92e9--info-icon--YyJFr","tooltip-list":"a10a3f92e9--tooltip-list--W5KIQ"};